<template>
    <div class="cst-survey-card-customer-data">
        <!-- <p class="cst-survey-welcome-customer-text" v-html="welcomeText"></p> -->
        <div class="cst-survey-customer-data-form">
            <form :data-vv-scope="validationScope">
                <fieldset class="cst-survey-customer">
                    <div>
                        <customer-field v-bind:validationScope="validationScope" v-bind:field="customer.title" /> 
                    </div>
                    <div>
                        <customer-field v-bind:validationScope="validationScope" v-bind:field="customer.firstname" /> 
                        <customer-field v-bind:validationScope="validationScope" v-bind:field="customer.lastname" /> 
                    </div>
                    <div>
                        <customer-field v-bind:validationScope="validationScope" v-bind:field="customer.email" /> 
                    </div>
                </fieldset>
                <fieldset class="cst-survey-visit">
                    <div>
                        <customer-field v-bind:validationScope="validationScope" v-bind:field="visit.from" /> 
                        <customer-field v-bind:validationScope="validationScope" v-bind:field="visit.to" /> 
                    </div>
                    <div>
                        <customer-field v-bind:validationScope="validationScope" v-bind:field="visit.room" /> 
                    </div>
                </fieldset>
                <!-- <span v-if="errors.any(validationScope)">  {{ errors.all(validationScope) }} </span>  -->
            </form>
            <div :class="{'privacy-consent': 1, 'required': errors.has( this.validationScope +'.privacy') }">
                <label :class="{'privacy-hint': 1 }">
                    <input type="checkbox" :data-vv-scope="this.validationScope" name="privacy" v-model="special.privacy" id="privacy-checkbox" v-validate data-vv-rules="required">
                    <span v-html="$t('txtPrivacyConsent',{'link': privacyLink, 'mail': privacyEmail})"></span>
                </label>
            </div>
            <span class="cst-field-error" v-show="errors.has(this.validationScope + '.privacy')">{{ $t("requiredField" )}}</span>
 
            <button class="btn-start" @click="next"> {{ $t("btnStart") }} </button>
            <div class="required-field-hint">* {{ $t("requiredField" )}}</div>
        </div>
    </div>

</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import CustomerField from './CustomerField'
    import BaseCardMixin from './BaseCardMixin.js'

    export default {
      mixins: [BaseCardMixin],
      props: ['content'],
      data: function () {
        return {
          customer: this.content.customer,
          visit: this.content.visit,
          special: { privacy: null },
          validationScope: 'customer'
        }
      },
      methods: {
        next: function () {
          this.$validator.validateAll(this.validationScope).then((hasPassed) => {
            if (hasPassed) {
              this.$store.dispatch('createSurvey', { customer: this.customer, visit: this.visit }).then(() => eventHub.$emit('card-next'))
            }
          })
        },
        getTitle: function () {
          return this.welcomeText
        }
      },
      watch: {
        welcomeText: function (a, b) {
          this.setTitle()
        }
      },
      computed: {
        welcomeText: function () {
          return this.$store.state.hotelData.text.welcome
        },
        privacyLink: function () {
          return this.$store.state.hotelData.hotel.urls.privacy
        },
        privacyEmail: function () {
          return this.$store.state.hotelData.hotel.email
        }
      },
      components: {
        CustomerField
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    button.cst-survey-next {
        .cst-survey-btn;
        background-color: @main-button-color;
    }

    .cst-field-error {
        .cst-field-error
    }

    .cst-survey-welcome-customer-text {
        font-size: 130%;
        margin: 0;
        margin-bottom: 0.5em;
        font-weight: 300;
        padding: 0 1em;
    }
    .cst-survey-card-customer-data {
        margin: 0.8em;
        margin-top: 0;
        width: 100%;
    }
    fieldset {
        border: none;
        padding: 0;
    }
    fieldset > div:not(:last-child) {
        margin-bottom: 0.5em;
    }
    .btn-start {
        .cst-survey-btn;
        margin: auto;
        display: flex;
        margin-top: 1em;
    }
    .required-field-hint {
        font-size: 80%;
        color: @border-color;
        margin: 1em;
        margin-left: 0;
    }
    .cst-survey-customer-data-form {
        border: 1px solid @border-color;
        padding: 1em;
        margin-top: 1em;
    }
    .cst-survey-welcome-customer-text {
        text-align: center;
    }
    .privacy-hint {
        font-size: 75%;
    }
    .privacy-hint a {
        text-decoration: underline;
    }
    .privacy-consent input {
        display: inline-block;
        width: auto;
    }
    .privacy-consent {
        padding-left: 0.3em;
    }
    .privacy-consent input {
        transform: scale(1.2);
    }
    // div.required {
    //     background-color: #FFF0F5;
    // }
    // .cst-survey-card-customer-data {
    //     min-height: 65vh;
    // }

</style>




// WEBPACK FOOTER //
// src/components/CardCustomerData.vue